import { render, staticRenderFns } from "./TextAreaModal.vue?vue&type=template&id=009188ee&scoped=true"
import script from "./TextAreaModal.vue?vue&type=script&lang=ts"
export * from "./TextAreaModal.vue?vue&type=script&lang=ts"
import style0 from "./TextAreaModal.vue?vue&type=style&index=0&id=009188ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009188ee",
  null
  
)

export default component.exports